import { createSlice } from '@reduxjs/toolkit';

import { dispatch } from '../index';
import {API} from "aws-amplify";

const apiName = process.env.REACT_APP_ENDPOINT_NAME;
const path_get_payables_details = process.env.REACT_APP_DASHBOARD_GET_PAYABLES_SINGLE;

const initialState = {
    list: null,
    pdf_data: "",
    details_error: null,
    error_message: ""
};

const payables = createSlice({
    name: 'payables',
    initialState,
    reducers: {
        hasError(state, action){
            state.details_error = action.payload.error;
        },
        getSingleList(state, action) {
            state.error_message = action.payload.data.error_message;
            state.list = action.payload.data.list;
            state.pdf_data = action.payload.data.pdf_data;
            return state;
        },
        handlerResetPayables(state, action){
            state.error_message = action.payload.error_message;
            state.list = action.payload.list;
            state.details_error = action.payload.details_error;
            state.pdf_data = action.payload.pdf_data;
        }
    }
});

export default payables.reducer;

export function getInvoiceSingleList(username, subscription_id, invoiceId){
    return async() => {
        var myInit = {};
        myInit = {
            headers: {},
            response: true,
            queryStringParameters: {
                "username": JSON.stringify(username),
                "subscription_id": subscription_id,
                "invoiceId": invoiceId
            }
        }
        API.get(apiName, path_get_payables_details, myInit)
            .then(response => {
                dispatch(payables.actions.getSingleList(response.data))
            }).catch(error => {
                dispatch(payables.actions.hasError(error))
        })
    };
}

export const {hasError, handlerResetPayables} = payables.actions;